import { FilterType } from "@studyportals/omnisearch-interfaces";

export const LOW_RESULTS_TITLE_FILTERTYPE_MAPPER: Map<FilterType, string> = new Map([
	[FilterType.DISCIPLINES, "View more results by searching for"],
	[FilterType.COUNTRY, "Or expand your search location"],
]);

export const LOW_RESULTS_ICON_CHIP_MAPPER: Map<FilterType, string> = new Map([
	[FilterType.DISCIPLINES, "lnr-arrow-right"],
	[FilterType.COUNTRY, "lnr-map-marker"],
	[FilterType.AREA, "lnr-map-marker"],
	[FilterType.CONTINENT, "lnr-map-marker"],
	[FilterType.KEYWORD, "lnr-map-marker"]
]);